import {Component, Input, OnInit} from '@angular/core';
import {TourApiService} from '../services/tour-api.service';
import {TourService} from '../services/tour.service';
import {RatingBarColor, RatingBarSize, RatingBarType} from '../model/feedback-info';

@Component({
  selector: 'gt-rating-bar',
  template: `
    <div class="rating-bar {{ ratingSizeClass }} {{ ratingBorderClass }}">
      <div class="rating-average {{ ratingScoreClass }}">{{ ratingScore }}</div>
      <div [ngClass]="barTypeClass()">{{ ratingText }}</div>
    </div>
  `,
    styles: [`.rating-bar {
      height: 4rem;
      font-family: Open Sans Condensed, Helvetica Neue, sans-serif;
      font-weight: 700;
      font-size: 2.25rem;
      line-height: 4rem;
    }
    .rating-bar-half {
      float: none;
      font-size: 2.0rem;
      margin-bottom: 15px;
    }

    @media (min-width: 765px) {
      .rating-bar-half {
        min-width: 46%;
        max-width: 48%;
        float: left;
        font-size: 1.65rem;
        margin-right: 15px;
      }
    }

    .rating-bar-mini {
      float: none;
      font-size: 1.1rem;
    }
    
    .rating-bar-mini .rating-stars {
      font-size: 2em;
      line-height: 3rem;
    }
    
    .rating-bar-mini .rating-average {
      height: 3rem;
      width: 3rem;
      font-size: 1.5rem;
      line-height: 2em;
    }

    .rating-average, .rating-text {
      float: left;
      overflow-x: hidden;
    }
    
    .rating-average {
      height: 4rem;
      width: 4rem;
      font-size: 2rem;
      color: #fff;
      text-align: center;
    }
    
    .rating-stars {
      font-family: FontAwesome, sans-serif;
      font-size: 3rem;
      line-height: 4rem;
      letter-spacing: 2px;
      float: left;
      padding-left: 10px;
      vertical-align: middle;
    }
    
    .rating-text {
      padding-left: 7px;
    }
    
    .grey-border {
      border: 2px solid #949799;
    }
    
    .orange-border {
      border: 2px solid #e18c28;
    }
  `]
})
export class RatingBarComponent implements OnInit {

  @Input() barType: RatingBarType;
  @Input() barSize: RatingBarSize;
  @Input() barColor: RatingBarColor;
  @Input() ratingScore: number;
  @Input() ratingText: string;
  ratingBorderClass: string;
  ratingScoreClass: string;
  ratingSizeClass: string;

  constructor(public apiService: TourApiService, private tourService: TourService) { }

  ngOnInit() {
    this.ratingText = (this.barType === RatingBarType.Stars)
                        ? this.tourService.getStarsStringForRating(this.ratingScore)
                        : this.ratingText;
    this.ratingBorderClass = (this.barType === RatingBarType.Text)
                              ? ((this.barColor === RatingBarColor.Orange) ? 'orange-border' : 'grey-border') : '';
    this.ratingScoreClass = (this.barColor === RatingBarColor.Orange) ? 'orange-bg' : 'lt-grey-bg';
    this.ratingSizeClass = (this.barSize === RatingBarSize.Half) ? 'rating-bar-half'
                              : ((this.barSize === RatingBarSize.Mini) ? 'rating-bar-mini' : '');
  }

  barTypeClass() {
    return ((this.barType === RatingBarType.Stars) ? 'rating-stars' : 'rating-text')
            + ((this.barColor === RatingBarColor.Orange) ? ' orange' : ' lt-grey');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/rating-bar.component.ts